import React, { useState } from "react";
import "../styles/layout/Sidebar.scss";
import { Avatar } from "primereact/avatar";
import { Link, useLocation } from "react-router-dom";
import MenuItem from "../types/sidebar";

const Sidebar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const [isCollapsed, setisCollapsed] = useState<boolean>(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleSidebar = () => {
    setIsMenuOpen(false);
    setisCollapsed(!isCollapsed);
  };

  const menuItems: MenuItem[] = [
    { path: "/", icon: "bi-house", label: "Dashboard" },
    { path: "/introduction", icon: "bi-info-circle", label: "Introduction" },
    { path: "/authentication", icon: "bi-passport", label: "Authentication" },
    { path: "/errors", icon: "bi-bug", label: "Errors" },
  ];

  const renderMenuItems = () =>
    menuItems.map((item) => (
      <li
        key={item.path}
        className={`menu-item ${isCollapsed ? "collapsed" : ""} ${
          location.pathname === item.path ? "active" : ""
        }`}
      >
        <Link to={item.path}>
          <i className={`bi ${item.icon} mr-3`}></i>
          {!isCollapsed && <span>{item.label}</span>}
        </Link>
      </li>
    ));

  return (
    <aside className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
      <div className="sidebar-header">
        <button className="toggle-button mt-2" onClick={toggleSidebar}>
          <i className="bi bi-list"></i>
        </button>
        <span className="sidebar-logo">{isCollapsed ? null : "Whatsup2u"}</span>
      </div>

      <nav className="sidebar-menu">
        <ul>{renderMenuItems()}</ul>
      </nav>

      {isCollapsed ? (
        <div className="user-menu">
          <div className="user-header">
            <Avatar
              label="V"
              size="large"
              style={{ backgroundColor: "#2196F3", color: "#ffffff" }}
              shape="circle"
            />
          </div>
        </div>
      ) : (
        <div className="user-menu">
          <div className="user-header" onClick={toggleMenu}>
            <Avatar
              label="V"
              size="large"
              style={{ backgroundColor: "#2196F3", color: "#ffffff" }}
              shape="circle"
              className="mr-2"
            />
            <span className="user-name">Amy Elsner</span>
            <i
              className={`bi ${
                isMenuOpen ? "bi-chevron-up mr-2" : "bi-chevron-down mr-2"
              } toggle-icon`}
            ></i>
          </div>
          {isMenuOpen && (
            <ul className="user-dropdown">
              <li>
                <i className="bi bi-person mr-2"></i> Profile
              </li>
              <li>
                <i className="bi bi-gear mr-2"></i> Settings
              </li>
              <li>
                <i className="bi bi-box-arrow-right mr-2"></i> Sign Out
              </li>
            </ul>
          )}
        </div>
      )}
    </aside>
  );
};

export default Sidebar;
